import { RootStackParamList } from '$tablet-app/src/app/navigation/RootStackNavigator';
import { CommonActions, StackActions } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { OpenCalendarItemCommand } from '../types';

type Params = {
  command: OpenCalendarItemCommand;
  navigation: NativeStackNavigationProp<RootStackParamList>;
};

export async function handleOpenCalendarItemCommand(
  params: Params
): Promise<void> {
  const result = OpenCalendarItemCommand.safeParse(params.command);
  if (!result.success) {
    console.warn('Error: ', result.error);
    return;
  }

  try {
    const { dispatch, getState } = params.navigation;

    const { data } = result.data;
    const { type, id, in_edit_mode, focused_field } = data;

    const navState = getState();
    const currentScreen: any = navState?.routes?.[navState?.routes?.length - 1];
    const desiredScreenName = in_edit_mode
      ? 'EditCalendarItem'
      : 'CalendarItemDetails';

    const isAlreadyOnScreen =
      currentScreen?.name === desiredScreenName &&
      currentScreen?.params?.id === id &&
      currentScreen?.params?.type === type;

    const navigateParams = { id, type, focused_field };

    if (isAlreadyOnScreen) {
      // If we are already on the screen, then we update the current screen's params
      dispatch({
        ...CommonActions.setParams(navigateParams),
        source: currentScreen.key,
      });
    } else {
      dispatch(StackActions.push(desiredScreenName, navigateParams));
    }
  } catch (ex) {
    console.warn('Handle Open Calendar Item:', ex);
  }
}
